export default __webpack_public_path__ + "static/media/ai-art-creator-shared.2c5ff436.svg";